import Hero from "components/Hero";
import About from "components/About";
import AwardsGallery from "components/AwardsGallery";
import ExpeditionCTA from "components/ExpeditionCTA";
import FeaturedProducts from "components/FeaturedProducts";
import FindUs from "components/FindUs";
import Testimonials from "components/Testimonials";

const Home = () => {
  return (
    <div className="relative min-h-screen">
      <main className="relative z-[1] [&>section:first-child]:mt-0 [&>section:first-child]:pt-0">
        <Hero />
        <About />
        <AwardsGallery />
        <Testimonials />
        <ExpeditionCTA />
        <FeaturedProducts />
        <FindUs />
      </main>
    </div>
  );
};

export default Home;
